module.exports = __webpack_public_path__ + "static/img/fish30.0d3b1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish30.png
// module id = jbqc
// module chunks = 0